import type { WordSense } from '@shared/types';

/** Смыслы карточки без «редких» и переводы «редких» отдельно (2026-09-23).
 *  «Редкие» — остаток строки словаря без примера и подсказки: их показывают одной
 *  строкой «редкие: …», а не нумерованным значением. */
export function splitRareSenses(senses: WordSense[]): { senses: WordSense[]; rare: string[] } {
  return {
    senses: senses.filter((sense) => !sense.isRare),
    rare: senses
      .filter((sense) => sense.isRare)
      .flatMap((sense) => sense.translations.map((translation) => translation.text)),
  };
}
